import { getBaseUrl } from "./chit_chats_print_agent_base_url";
import {
  ADVANCED_TOGGLE_CLASS,
  SELECT_BUTTON_CLASS,
  applyPrintMethodSelectionStyle,
  methodFromButton,
  printMethodMessages,
  readOrDefaultPrintMethodCookie,
  renderPrintMethodList,
  setSelectedPrintMethodMessage,
  toggleAdvancedPrintMethods,
  writePrintMethodCookie
} from "./chit_chats_print_agent_print_methods";

var beforeRefreshPrinters = null;

function setPrinterRefreshState(refreshBtn, messages, isLoading) {
  refreshBtn.disabled = isLoading;
  refreshBtn.textContent = isLoading ? messages.refreshing : messages.refresh;
}

function fetchPrinters(baseUrl) {
  return fetch(baseUrl + "/v1/printers", { method: "GET" }).then(function(resp) {
    if (!resp.ok) {
      throw new Error("printer-list-failed");
    }
    return resp.json();
  });
}

function refreshPrinters(container, refreshBtn, messages) {
  var listEl = container.querySelector(".js-chit-chats-print-printer-list");
  setPrinterRefreshState(refreshBtn, messages, true);
  if (listEl) {
    listEl.textContent = messages.loading;
  }

  fetchPrinters(getBaseUrl()).then(function(body) {
    renderPrintMethodList(container, body && body.printers, messages);
  }).catch(function() {
    if (listEl) {
      listEl.textContent = messages.error;
    }
  }).finally(function() {
    setPrinterRefreshState(refreshBtn, messages, false);
  });
}

function runRefreshPrinters(container, refreshBtn, messages) {
  var readiness = beforeRefreshPrinters ? beforeRefreshPrinters() : Promise.resolve(true);
  Promise.resolve(readiness).then(function(shouldRefresh) {
    if (shouldRefresh === false) {
      return;
    }
    refreshPrinters(container, refreshBtn, messages);
  }).catch(function(refreshErr) {
    if (window.console) {
      window.console.error("chitChatsPrint printer refresh readiness failed", refreshErr);
    }
  });
}

function bindPrinterSelection(container, messages) {
  container.addEventListener("click", function(event) {
    var button = event.target.closest("." + SELECT_BUTTON_CLASS);
    if (!button) {
      return;
    }

    var savedMethod = writePrintMethodCookie(methodFromButton(button));
    // In-place toggle — no fetch, no innerHTML rewrite — keeps the panel
    // stable while the user clicks through print methods.
    applyPrintMethodSelectionStyle(container, savedMethod, messages);
    setSelectedPrintMethodMessage(container, savedMethod, messages);
  });

  container.addEventListener("click", function(event) {
    if (event.target.closest("." + ADVANCED_TOGGLE_CLASS)) {
      toggleAdvancedPrintMethods(container);
    }
  });
}

function findPrinterSetupElements() {
  var container = document.querySelector(".js-chit-chats-print-printers");
  var refreshBtn = document.querySelector(".js-chit-chats-print-printers-refresh");
  if (!container || !refreshBtn) {
    return null;
  }
  return { container: container, refreshBtn: refreshBtn };
}

// BindPrinterSetupHandlers wires up the refresh button + print-method row
// click handlers and shows the last saved print method from the cookie. It
// deliberately does NOT issue any local-network requests — the caller
// (setup status state machine) decides when an explicit connect/refresh
// happens. Idempotent: safe to call repeatedly.
function bindPrinterSetupHandlers(options) {
  var els = findPrinterSetupElements();
  if (!els) {
    return;
  }
  if (options && options.beforeRefresh) {
    beforeRefreshPrinters = options.beforeRefresh;
  }
  if (els.refreshBtn.dataset.handlersBound === "true") {
    return;
  }
  var messages = printMethodMessages(els.container);
  bindPrinterSelection(els.container, messages);
  els.refreshBtn.addEventListener("click", function() {
    runRefreshPrinters(els.container, els.refreshBtn, messages);
  });
  setSelectedPrintMethodMessage(els.container, readOrDefaultPrintMethodCookie(messages), messages);
  els.refreshBtn.dataset.handlersBound = "true";
}

// RefreshPrintersFromApp triggers an explicit fetch from the local
// app. Always re-fetches, even if previously called — this is what
// the setup status machine calls after a successful Connect, so the
// list refreshes regardless of an earlier fetch having failed.
function refreshPrintersFromApp() {
  var els = findPrinterSetupElements();
  if (!els) {
    return;
  }
  bindPrinterSetupHandlers();
  var messages = printMethodMessages(els.container);
  refreshPrinters(els.container, els.refreshBtn, messages);
}

// Legacy export. Kept so any pre-existing call site that hasn't been
// updated still works, but new callers should prefer the explicit
// bind / refresh split above.
function initializeChitChatsPrintPrinterSetup() {
  bindPrinterSetupHandlers();
  refreshPrintersFromApp();
}

export {
  initializeChitChatsPrintPrinterSetup,
  bindPrinterSetupHandlers,
  refreshPrintersFromApp
};
